const AWS_LAMBDA_LINK = 'https://q9z0ihxlda.execute-api.us-east-1.amazonaws.com';

// DEVELOPMENT Links
export const GEO_TRELLIS__ANALYZE_LIST_DEV: string = AWS_LAMBDA_LINK + '/AnalyzeList/latest';

// QA Links
export const GEO_TRELLIS__ANALYZE_LIST_QA: string = AWS_LAMBDA_LINK + '/AnalyzeList/qa';

// STAGING Links
export const GEO_TRELLIS__ANALYZE_LIST_STAGING: string = AWS_LAMBDA_LINK + '/AnalyzeList/staging';

// PRODUCTION Links
export const GEO_TRELLIS__ANALYZE_LIST_PROD: string = AWS_LAMBDA_LINK + '/AnalyzeList/production';

// ProdV2 Links
export const GEO_TRELLIS__ANALYZE_LIST_PRODV2: string = AWS_LAMBDA_LINK + '/AnalyzeList/prodv2';
